import SimpleModel from './SimpleModel';
import immutable from '../../helpers/immutable';

export default class SimpleReadonlyModel<Records extends Record<string, any>> extends SimpleModel<Records> {
	constructor(attributes: Records) {
		super(immutable(attributes));
	}

	// eslint-disable-next-line
	setAttribute(key: keyof Records, value: Records[keyof Records]): void {
	}
}
